import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, ArrowRightIcon } from 'lucide-react';
import { Logo } from './Logo';
const NAV_LINKS = [{
  label: 'Inicio',
  href: '#inicio'
}, {
  label: 'Productos',
  href: '#productos'
}, {
  label: 'Nosotros',
  href: '#nosotros'
}, {
  label: 'Blog',
  href: '#blog'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <header className="fixed inset-x-0 top-0 z-50" data-id="element-73" data-mp="3fc9lo0jyv05h">
      <div className={`transition-all duration-500 ${scrolled ? 'border-b border-white/[0.06] bg-[#0d0d0f]/80 backdrop-blur-xl' : 'border-b border-transparent'}`} data-id="element-74" data-mp="2wkkydbxg5m38">
        <div className="mx-auto flex h-[68px] w-full max-w-content items-center justify-between px-6 lg:px-8" data-id="element-75" data-mp="2mlvghj5jw1mz">
          <Logo data-id="element-76" data-mp="2hovi7uey036f" />

          <nav aria-label="Navegación principal" className="hidden lg:block" data-id="element-77" data-mp="2hpeqejesjd79">
            <ul className="flex items-center gap-1" data-id="element-78" data-mp="3fa0za0d1ngk6">
              {NAV_LINKS.map(link => <li key={link.label} data-id="element-79" data-mp="3adkb565uh273">
                  <a href={link.href} className="rounded-full px-4 py-2 text-sm text-white/60 transition-colors duration-200 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30" data-id="element-80" data-mp="3aelmzcuopspv">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="flex items-center gap-2" data-id="element-81" data-mp="3t9af2yxc88nm">
            <a href="#productos" className="group brand-gradient-bg hidden items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium text-white shadow-[0_16px_40px_-16px_rgba(90,80,246,0.8)] transition-all duration-300 hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 sm:inline-flex" data-id="element-82" data-mp="1remf6mnzy6hr">
              Explorar Productos
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-83" data-mp="18lii0rbklbie" />
            </a>
            <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="grid h-10 w-10 place-items-center rounded-xl border border-white/10 bg-white/[0.03] text-white/80 transition-colors hover:text-white lg:hidden" data-id="element-84" data-mp="yq7aou2hr6ko">
              {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-85" data-mp="mf69kmz3ew3w" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-86" data-mp="hgmqcubvvyf8" />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-87" data-mp="w6appq0i8n0b">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} className="border-b border-white/[0.06] bg-[#0d0d0f]/95 backdrop-blur-xl lg:hidden" data-id="element-88" data-mp="rdhnp9wf7srx">
            <nav aria-label="Navegación móvil" className="px-6 py-6" data-id="element-89" data-mp="1f2tu620d5mqj">
              <ul className="space-y-1" data-id="element-90" data-mp="1a5adywk3uzvy">
                {NAV_LINKS.map(link => <li key={link.label} data-id="element-91" data-mp="3gu6ximmonmkh">
                    <a href={link.href} onClick={() => setOpen(false)} className="block rounded-xl px-3 py-3 text-base text-white/70 transition-colors hover:bg-white/[0.04] hover:text-white" data-id="element-92" data-mp="3guyr5rwpza84">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
              <a href="#productos" onClick={() => setOpen(false)} className="brand-gradient-bg mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-medium text-white" data-id="element-93" data-mp="2cxcuoqffh7ix">
                Explorar Productos
                <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-94" data-mp="1p7iimb2xnmzq" />
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}